export const ADD_VEHICLE_REQUEST = 'ADD_VEHICLE_REQUEST'
export const ADD_VEHICLE_SUCCESS = 'ADD_VEHICLE_SUCCESS'
export const ADD_VEHICLE_FALIURE = 'ADD_VEHICLE_FALIURE'
